import { useEffect } from 'react';
import { initializeProgressData, useProgress } from './useProgress';
import OpeningAnimation from '../../../components/opening_animation/OpeningAnimation';
import Constants from '../../../utils/Constants';
import Modal from '../../../components/modal/Modal';
import Variables from '../../../style/variables.scss';
import { extractDriveId } from '../../../utils/ExtractDriveId';

const Progress = () => {
  const {
    isInitialized,
    setIsInitialized,
    progressData,
    setProgressData,
    openModal,
    setOpenModal,
  } = useProgress();

  const driveId = extractDriveId(progressData?.progressMediaUrl);
  const previewUrl = `https://drive.google.com/file/d/${driveId}/preview`;

  useEffect(() => {
    const loadApartments = async () => {
      if (isInitialized) return;

      try {
        const progress = await initializeProgressData();
        setProgressData(progress);
        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to load progress:', error);
      }
    };

    loadApartments();
  }, [isInitialized]);

  return (
    <div id={Constants.PROGRESS_SECTION} className='progress'>
      <Modal
        id='progressImage'
        isOpen={openModal}
        onClose={setOpenModal}
        primaryColor={Variables.secondaryColor}
        secondaryColor={Variables.primaryColor}
      >
        <div className='progress_image'>
          <h2>{progressData?.progressMediaDate}</h2>
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <iframe
              src={previewUrl}
              title={progressData?.progressMediaDate}
              allow='autoplay; encrypted-media'
              allowFullScreen
              style={{
                width: '100%',
                height: '100%',
                border: 0,
                display: 'block',
              }}
            />
          </div>
        </div>
      </Modal>
      <OpeningAnimation isOpen={!isInitialized} isInitial />
      <div className='progress_view container'>
        <h2 data-aos='fade-up' className='title_underline_light'>
          DETALJI PROJEKTA
        </h2>
        <div className='progress_view_grid text_right'>
          <div data-aos='fade-up' data-aos-delay='50'>
            <h3>POČETAK GRADNJE</h3>
            <p>{progressData?.startDate}</p>
          </div>
          <div data-aos='fade-up' data-aos-delay='100'>
            <h3>PLANIRANI ZAVRŠETAK GRADNJE</h3>
            <p>{progressData?.endDate}</p>
          </div>
        </div>
        <div className='progress_view_grid'>
          <div data-aos='fade-up' data-aos-delay='150'>
            <h3>DOVRŠETAK</h3>
            <div>
              <div
                data-aos='fade-right'
                data-aos-delay='650'
                style={{ width: `${progressData?.ending}%` }}
              ></div>
            </div>
          </div>
          <div data-aos='fade-up' data-aos-delay='200'>
            <h3>PLANIRANJE I PROJEKTIRANJE</h3>
            <div>
              <div
                data-aos='fade-right'
                data-aos-delay='700'
                style={{ width: `${progressData?.planing}%` }}
              ></div>
            </div>
          </div>
          <div data-aos='fade-up' data-aos-delay='250'>
            <h3>FAZA GRADNJE</h3>
            <div>
              <div
                data-aos='fade-right'
                data-aos-delay='750'
                style={{ width: `${progressData?.phase}%` }}
              ></div>
            </div>
          </div>
          <div data-aos='fade-up' data-aos-delay='300'>
            <h3>UREĐIVANJE INTERIJERA</h3>
            <div>
              <div
                data-aos='fade-right'
                data-aos-delay='800'
                style={{ width: `${progressData?.interior}%` }}
              ></div>
            </div>
          </div>
        </div>
        <div
          data-aos='fade-up'
          data-aos-delay='350'
          className='progress_view_button button'
        >
          <div
            className='opacity_transition_low'
            onClick={() => setOpenModal(true)}
          >
            SLIKA TRENUTNOG STANJA
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progress;
